import styled from 'styled-components'

export const FooterWrapper = styled.footer`
	display: flex;
	background-color: hsl(351, 34%, 70%);
	padding: 40px 15px;
	align-items: center;
	justify-content: center;
`

export const FooterText = styled.div`
	font-size: 0.825rem;
	color: white;
	font-family: monospace;
	text-align: center;

	a {
		color: white;
		transition: all 0.2s ease-in-out;

		&:hover {
			color: white;
			opacity: 0.7;
		}
	}
`
